export * from './berichte-filter.component';
export * from './berichte-filter.component.module';